import React from 'react';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import PropTypes from 'prop-types';
// Colors
import { statusPalette } from 'components/core/colors';
// Models
import { icon, installationName, isDisabled } from 'models/device';
// Custom
import { deviceDataShape } from 'constants/PropTypesShapes';
import InformationItem from 'components/items/InformationItem';
import AppIcon from 'components/icons/AppIcon';

const DeviceDescItem = ({ device, light }) => {
  if (device) {
    const disabled = isDisabled(device);
    return (
      <InformationItem
        light={light}
        icon={icon}
        label={<LocalizedMessage id={disabled ? 'field.deviceDisabled' : 'field.device'} />}
        value={installationName(device)}
        rightIcon={
          disabled ? (
            <AppIcon id="disabled" color={statusPalette.warning} />
          ) : null
        }
        gender="male"
      />
    );
  }
  return null;
};

DeviceDescItem.propTypes = {
  device: deviceDataShape,
  light: PropTypes.bool,
};

DeviceDescItem.defaultProps = {
  device: null,
  light: false,
};

module.exports = DeviceDescItem;



// WEBPACK FOOTER //
// ./routes/app/routes/devices/assets/main/DeviceDescItem.js